"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.BannerHvaIncentive=void 0;var e;(function(n){n.FreeDelivery="free_delivery"})(e||(exports.BannerHvaIncentive=e={}));
//# sourceMappingURL=BannerHvaIncentive.js.map
